// note: general import
// import MiniDrawer from "components/Drawer/Drawer";
import React, { useEffect } from "react";
import "../../App.css";

import {
  Avatar,
  Box,
  Container,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { Page } from "components/NonReusable/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { selectPelette, selectUser, userAction } from "state/reducer/user";
import Footer from "layout/Dashboard/Footer";
import Loader from "components/Loader";
import Drawer from "layout/Dashboard/Drawer";
import {
  Button,
  Paper,
  Grid,
  Divider,
  Chip,
  IconButton,
  AvatarGroup,
  Checkbox,
} from "@mui/material";
import {
  ShareOutlined,
  Add,
  AccessTime,
  CheckCircleOutline,
  HourglassTop,
  ExpandMore,
  HelpOutline,
  MapOutlined,
  RedeemOutlined,
  ChatBubbleOutline,
  AttachFile,
  MoreHoriz,
  MoreVert,
  CalendarMonthOutlined,
  NotesOutlined,
} from "@mui/icons-material";

import Header from "layout/Dashboard/Header";
import { notificationAction } from "state/reducer/notification";

// --- STYLING & DATA ---
const mainBgColor = "#f9fafb";
const cardBorderRadius = "16px";
const primaryPurple = "#755fed"; // Mengambil warna ungu dari contoh sebelumnya
const primaryGreen = "#34c759";
const primaryPink = "#ff2d55";

// --- DATA TIRUAN (MOCK DATA) ---
const projectTasks = [
  {
    icon: <HelpOutline />,
    name: "Help DStudio get more customers",
    comments: 7,
    attachments: 2,
    assignee: {
      name: "Phoenix Winters",
      avatar: "https://i.pravatar.cc/150?img=1",
    },
    status: "In Progress",
  },
  {
    icon: <MapOutlined />,
    name: "Plan a trip",
    comments: 10,
    attachments: 3,
    assignee: {
      name: "Cohen Merritt",
      avatar: "https://i.pravatar.cc/150?img=2",
    },
    status: "Pending",
  },
  {
    icon: <RedeemOutlined />,
    name: "Return a package",
    comments: 5,
    attachments: 8,
    assignee: {
      name: "Lukas Juarez",
      avatar: "https://i.pravatar.cc/150?img=3",
    },
    status: "Completed",
  },
];

const scheduleEvents = [
  {
    title: "Kickoff Meeting",
    time: "01:00 PM to 02:30 PM",
    color: primaryGreen,
    avatars: [
      "https://i.pravatar.cc/150?img=4",
      "https://i.pravatar.cc/150?img=5",
    ],
  },
  {
    title: "Create Wordpress website for Event Registration",
    time: "04:00 PM to 02:30 PM", // Waktu dari gambar sepertinya typo, saya ikuti
    color: primaryPurple,
    avatars: [
      "https://i.pravatar.cc/150?img=6",
      "https://i.pravatar.cc/150?img=7",
      "https://i.pravatar.cc/150?img=8",
    ],
  },
  {
    title: "Create User flow for hotel booking",
    time: "05:00 PM to 02:30 PM",
    color: primaryPink,
    avatars: [
      "https://i.pravatar.cc/150?img=9",
      "https://i.pravatar.cc/150?img=10",
    ],
  },
];

const notes = [
  {
    title: "Landing Page For Website",
    desc: "To get started on a landing page, could you provide a bit more detail about its purpose?",
    checked: false,
    color: "#9e9e9e", // Abu-abu
  },
  {
    title: "Fixing icons with dark backgrounds",
    desc: "Use icons that are easily recognizable and straightforward. Avoid overly complex designs that might confuse users",
    checked: false,
    color: "#9e9e9e",
  },
  {
    title: "Discussion regarding userflow improvement",
    desc: "What’s the main goal of the landing page? (e.g., lead generation, product)",
    checked: true,
    color: primaryPurple,
  },
];

const days = [
  { day: "Mo", date: 15 },
  { day: "Tu", date: 16 },
  { day: "We", date: 17, active: true },
  { day: "Th", date: 18 },
  { day: "Fr", date: 19 },
  { day: "Sa", date: 20 },
  { day: "Su", date: 14 },
];

// --- FUNGSI HELPER ---
const getStatusChip = (status) => {
  let backgroundColor, color;
  switch (status) {
    case "In Progress":
      backgroundColor = "rgba(52, 199, 89, 0.1)"; // Hijau muda
      color = "#34c759";
      break;
    case "Pending":
      backgroundColor = "rgba(120, 95, 237, 0.1)"; // Ungu muda
      color = primaryPurple;
      break;
    case "Completed":
      backgroundColor = "rgba(0, 122, 255, 0.1)"; // Biru muda
      color = "#007aff";
      break;
    default:
      backgroundColor = "#f0f0f0";
      color = "#000";
  }
  return (
    <Chip
      label={status}
      size="small"
      sx={{ backgroundColor, color, fontWeight: "bold" }}
    />
  );
};

// note: component import

export default function Main() {
  // return <MiniDrawer />;

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <Header />
      <Drawer />

      <Box
        component="main"
        sx={{
          width: "calc(100% - 260px)",
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
        }}
      >
        <Toolbar sx={{ mt: "inherit" }} />
        <Container
          maxWidth={"xl"}
          sx={{
            // ...(container && { px: { xs: 0, sm: 2 } }),
            position: "relative",
            minHeight: "calc(100vh - 110px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* note: route pages are React.lazy (see App.js); keep drawer/header visible while a chunk loads */}
          <React.Suspense fallback={<Loader />}>
            <Outlet />
          </React.Suspense>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
}
